import Vue from "vue";
import Router from "vue-router";
import AppHeader from "./layout/AppHeader";
import AppFooter from "./layout/AppFooter";
import Components from "./views/Components.vue";
import Home from "./views/Home.vue";
import SoftwareServices from "./views/Software-Services.vue";
import Register from "./views/Register.vue";
import AboutUs from "./views/About-Us.vue";
import Careers from "./views/Careers.vue";
import ContactUs from "./views/Contact-Us.vue";
import Pricing from "./views/Pricing.vue";
import Consulting from "./views/Consulting.vue";
import OfficeConsulting from "./views/Office-365-consulting.vue";
import ApplicationModernization from "./views/Application-Modernization.vue";

Vue.use(Router);

export default new Router({
  linkExactActiveClass: "active",
  mode: 'history',
  routes: [
    {
      path: "/",
      name: "home",
      components: {
        header: AppHeader,
        default: Home,
        footer: AppFooter
      }
    },
    
    {
      path: "/about-us",
      name: "about-us",
      components: {
        header: AppHeader,
        default: AboutUs,
        footer: AppFooter
      }
    },
    {
      path: "/technology-consulting",
      name: "Consulting",
      components: {
        header: AppHeader,
        default: Consulting,
        footer: AppFooter
      }
    },
    
    {
      path: "/careers",
      name: "careers",
      components: {
        header: AppHeader,
        default: Careers,
        footer: AppFooter
      }
    },
    {
      path: "/contact-us",
      name: "ContactUs",
      components: {
        header: AppHeader,
        default: ContactUs,
        footer: AppFooter
      }
    },
    {
      path: "/software-services",
      name: "software-services",
      components: {
        header: AppHeader,
        default: SoftwareServices,
        footer: AppFooter
      }
    },
    {
      path: "/pricing",
      name: "pricing",
      components: {
        header: AppHeader,
        default: Pricing,
        footer: AppFooter
      }
    },
    {
      path: "/office365-consulting",
      name: "Office-365-consulting",
      components: {
        header: AppHeader,
        default: OfficeConsulting,
        footer: AppFooter
      },
      
    },
    {
      path: "/application-modernization",
      name: "Application-Modernization",
      components: {
        header: AppHeader,
        default: ApplicationModernization,
        footer: AppFooter
      },
      
    },
  ],
  scrollBehavior: to => {
    if (to.hash) {
      return { selector: to.hash };
    } else {
      return { x: 0, y: 0 };
    }
  }
});
